import { Button, Card, CardActions, CardContent, Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import useStyles from './styles';
import { useEffect, useState } from 'react';
import StatusField from '../../Components/From/StatusField';
import { useUserContext } from '../../Services/Providers';

const BookingConfirmation = (props) => {
  const [pageTitle, setPageTitle] = useState('');
  const classes = useStyles();

  useEffect(() => {
    setTimeout(() => {
      setPageTitle(<FormattedMessage id='appointmentBookingConfirmed' />);
    }, 1000);
  }, []);

  const { lastAppointmentId, lastAppointmentHasIntake } = useUserContext().userContextObj;
  return (
    <div>
      <StatusField>{pageTitle}</StatusField>
      <Card
        className={classes.root}
        tabIndex='0'
      >
        <CardContent>
          <h1 className={classes.title}>
            <FormattedMessage id='appointmentBookingConfirmed' />
          </h1>
          <p>
            <FormattedMessage id='You can check, change or cancel your appointment online' />
          </p>
          {lastAppointmentHasIntake && (
            <div className={classes.intakeFormCallout}>
              <Typography className={classes.intakeMessage}>
                <FormattedMessage id="intakeFromAvailable1" />
                <Link
                  component="button"
                  className={classes.formButton}
                  onClick={() =>
                    props.history.push(`/intake-appointment/${lastAppointmentId}`)
                  }
                >
                  <FormattedMessage id="intakeFromAvailable2" />
                </Link>
                <FormattedMessage id="intakeFromAvailable3" />
              </Typography>
            </div>
          )}
        </CardContent>
        <CardActions>
          <Button
            size='small'
            onClick={() => props.history.push('/appointments')}
            className={classes.upcomingButton}
            focusRipple={false}
          >
            <FormattedMessage id='Upcoming appointments' />
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};

export default BookingConfirmation;
